export default "__VITE_ASSET__d166398b__"